<div>
  <app-rubros-lista></app-rubros-lista>
</div>
